'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var ErrorCodes = {
    AMS_ERR: 102,
    AIS: 104,
    FUNGUS: 105,
    VACCOUNT: 106,
    NET_ERR: 103,
    USER_INACTIVE: 101,
    MISS_PARAMETER: 601,
    USER_ERR: 400,
    APP_ERR: 602,
    PLAYER_ERR: 700,
    CDN_ERR: 800
};

exports.ErrorCodes = ErrorCodes;
